import { render, staticRenderFns } from "./leftTemplate.vue?vue&type=template&id=8d0dc47e&scoped=true&"
import script from "./leftTemplate.vue?vue&type=script&lang=js&"
export * from "./leftTemplate.vue?vue&type=script&lang=js&"
import style0 from "./leftTemplate.vue?vue&type=style&index=0&id=8d0dc47e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0dc47e",
  null
  
)

export default component.exports